export * from "./home-page.template";
